import { gql } from '@apollo/client'

const getNonconfigurableOrderPartConfigInfoQuery = gql`
    query getNonconfigurableOrderPartConfigInfo($orderName: String!) {
        getNonconfigurableOrderPartConfigInfo(orderName: $orderName) {
            fileName
            processes {
                id
                name
            }
            materials {
                id
                name
                processTechnologyId
            }
            postProcesses {
                id
                name
                color
            }
            secondaryProcesses {
                id
                name
            }
        }
    }
`

export default getNonconfigurableOrderPartConfigInfoQuery
